import { inject, Ref } from "vue";

import { ICompetitionFullMeta } from "../interfaces/channel/commons";

export const channelProvideSymbol = Symbol("valuesource");
export const useProvidedChannel = <T extends ICompetitionFullMeta>() => inject<Ref<T>>(channelProvideSymbol);
